import { z } from 'zod';

import type { DateInput } from '@/lib/dates';

/** Valeurs du formulaire « Sortie des véhicules de la flotte ». */
export interface SortieVehiculesValues {
    contract_id: number;
    selected_vehicules: (string | number)[];
    date_sortie: DateInput;
}

/** Contrôle de la sortie de véhicules (ancien `SortieVehicules/validate.js`). */
export const sortieVehiculesSchema = z.looseObject({}).superRefine((values, ctx) => {
    const v = values as Partial<SortieVehiculesValues>;
    const errors: Record<string, string> = {};

    if (!v.date_sortie) {
        errors.date_sortie = 'La date de sortie est obligatoire';
    }

    if (!v.selected_vehicules || v.selected_vehicules.length === 0) {
        errors.selected_vehicules = 'Veuillez sélectionner au moins un véhicule à supprimer';
    }

    for (const [path, message] of Object.entries(errors)) ctx.addIssue({ code: 'custom', path: [path], message });
});
